import { FormControl, FormGroupDirective } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class MyErrorStateMatcher implements ErrorStateMatcher {

  constructor(
    private chargeExcel: boolean,
    private typeError: string
  ) { }

  public isErrorState(control: FormControl | null, form: FormGroupDirective): boolean {
    const typesError = {
      required: { function: this.errorRequired, parameter: control },
      cups: { function: this.errorCups, parameter: control },
      dni: { function: this.errorDni, parameter: control },
      mobile: { function: this.errorMobile, parameter: control },
      email: { function: this.errorEmail, parameter: control },
      iban: { function: this.errorIban, parameter: form },
    };
    const typeError = typesError[this.typeError];
    const result = typeError.function(typeError.parameter);
    if (this.chargeExcel || this.typeError === 'iban') {
      return result;
    } else {
      return result && (control.touched || control.dirty);
    }
  }

  private errorRequired = (control: FormControl): boolean => {
    return control.errors?.required;
  }

  private errorCups = (control: FormControl): boolean => {
    return this.errorRequired(control) || (!!control.value && !!control.errors?.invalid_cups);
  }

  private errorDni = (control: FormControl): boolean => {
    return this.errorRequired(control) || (!!control.value && (control.errors?.invalid_dni || !!control.errors?.invalid_cif));
  }

  private errorMobile = (control: FormControl): boolean => {
    return this.errorRequired(control) || (!!control.value && control.errors?.invalid_mobile);
  }

  private errorEmail = (control: FormControl): boolean => {
    return this.errorRequired(control) || (!!control.value && !!control.errors?.pattern);
  }

  private errorIban = (formDirective: FormGroupDirective): boolean => {
    const keysObject = Object.keys(formDirective.form.controls).filter(val => val.startsWith('iban'));
    const haveValues = keysObject.some(key => !!formDirective.form.get(key).value);
    const touchedOrDirty = keysObject.some(key => formDirective.form.get(key).touched || formDirective.form.get(key).dirty);
    const haveError = haveValues && formDirective.form.hasError('invalid_IBAN');
    if (this.chargeExcel) {
      return !haveValues || haveError;
    } else {
      return haveError && touchedOrDirty;
    }
  }
}
